import { render, staticRenderFns } from "./MPMultiple.vue?vue&type=template&id=359283b5&"
import script from "./MPMultiple.vue?vue&type=script&lang=js&"
export * from "./MPMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports